/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Ethics_Title6Inputs */

const en_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal-safe methodology`)
};

const ar_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منهجية آمنة قانونيًا`)
};

const bn_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিগ্যাল-সেফ মেথডোলজি`)
};

const de_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtssichere Methodik`)
};

const es_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metodología legalmente segura`)
};

const fr_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Méthodologie juridiquement sûre`)
};

const pt_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metodologia legalmente segura`)
};

const zh_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合法安全的方法`)
};

const tr_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yasal açıdan güvenli metodoloji`)
};

const ru_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Юридическая методология`)
};

const pl_svc_web_scraping_ethics_title6 = /** @type {(inputs: Svc_Web_Scraping_Ethics_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metodologia bezpieczna pod względem prawnym`)
};

/**
* | output |
* | --- |
* | "Legal-safe methodology" |
*
* @param {Svc_Web_Scraping_Ethics_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_ethics_title6 = /** @type {((inputs?: Svc_Web_Scraping_Ethics_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Ethics_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_ethics_title6(inputs)
	if (locale === "bn") return bn_svc_web_scraping_ethics_title6(inputs)
	if (locale === "de") return de_svc_web_scraping_ethics_title6(inputs)
	if (locale === "es") return es_svc_web_scraping_ethics_title6(inputs)
	if (locale === "fr") return fr_svc_web_scraping_ethics_title6(inputs)
	if (locale === "pt") return pt_svc_web_scraping_ethics_title6(inputs)
	if (locale === "zh") return zh_svc_web_scraping_ethics_title6(inputs)
	if (locale === "tr") return tr_svc_web_scraping_ethics_title6(inputs)
	if (locale === "ru") return ru_svc_web_scraping_ethics_title6(inputs)
	if (locale === "pl") return pl_svc_web_scraping_ethics_title6(inputs)
	return en_svc_web_scraping_ethics_title6(inputs)
});
export { svc_web_scraping_ethics_title6 as "svc_web-scraping_ETHICS_title" }